import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { TrackDetailsContainer, styles } from "./styles";
import { Waveform, WaveformEvents } from "@dolbyio/media-uikit-react";
import { DetailsProps } from "./types";
import { useCallback, useEffect } from "react";
import { Tooltip } from "@mui/material";
import { hideVolumeControl } from "../../utils/DolbyIoUtils";
import { TEXT_COLOR } from "../../theme";

export const Details: React.FC<DetailsProps> = ({
  track,
  setPreviewStartValue,
  setDuration,
}) => {
  const onPreviewUpdated = useCallback(
    (previewDetails: any) => {
      const {
        detail: { start, end },
      } = previewDetails;
      setPreviewStartValue(start);
      setDuration(Math.floor(end - start));
    },
    [setDuration, setPreviewStartValue]
  );

  useEffect(() => {
    hideVolumeControl();
    window &&
      window.addEventListener(WaveformEvents.RegionUpdated, (previewDetails) =>
        onPreviewUpdated(previewDetails)
      );
    return () => {
      window.removeEventListener(
        WaveformEvents.RegionUpdated,
        (previewDetails: any) => onPreviewUpdated(previewDetails)
      );
    };
  }, [onPreviewUpdated]);

  return (
    <>
      <TrackDetailsContainer>
        <Box sx={styles.trackImageContainer}>
          <img
            style={styles.trackImage}
            src={
              track.track?.getImageUrl() !== undefined &&
              track.track?.getImageUrl().includes("http")
                ? track.track?.getImageUrl()
                : `/assets/images/logo-icon.png`
            }
            alt="TrackImage"
          />
        </Box>
        <Box sx={styles.trackImageContainer}>
          <Box>
            <Box sx={styles.trackDetailsContainer}>
              <Box sx={{ width: "50px" }}>
                <Typography style={{ fontWeight: "bold" }}>Title</Typography>
              </Box>
              <Typography>{track.track?.getTitle()}</Typography>
            </Box>
            <Box sx={styles.trackDetailsContainer}>
              <Box sx={styles.trackDetailsContainerBox}>
                <Typography style={styles.trackDetailsContainerBoxText}>
                  Artist
                </Typography>
              </Box>
              <Typography> {track.track?.getArtist()}</Typography>
            </Box>
            <Box sx={styles.trackDetailsContainer}>
              <Box sx={styles.trackDetailsContainerBox}>
                <Typography style={styles.trackDetailsContainerBoxText}>
                  Genre
                </Typography>
              </Box>
              <Typography>
                {track.track
                  ?.getSongMetadata()
                  ?.getGenreList()[0]
                  .split(" ")
                  .join(", ")}
              </Typography>
            </Box>
          </Box>
        </Box>
      </TrackDetailsContainer>
      <hr />
      <p style={{ color: TEXT_COLOR }}>Please choose the preview window</p>
      <Tooltip title="Choose the preview window" style={{ color: TEXT_COLOR }}>
        <Box>
          <Waveform
            hasLoopControl={false}
            previewActive={true}
            preview={{ start: 0, end: 30 }}
            url={track.trackUrl}
          />
        </Box>
      </Tooltip>
    </>
  );
};
